module.exports = __webpack_public_path__ + "img/bag.b822f44d.svg";